import { SmartQMoveEvent, SmartQMultiMoveEvent } from "./SmartQEvent" // eslint-disable-line no-unused-vars

export const defaultOptions = {
  selected: [],
  selectedLabels: [],
}

export default class SmartQDraggableGrid {
  // eslint-disable-line no-unused-vars
  constructor(draggable) {
    this.draggable = draggable

    this.options = {
      ...defaultOptions,
      ...this.getOptions(),
    }

    this.elements = []
    this.mirror = null
    this.selectedMirrors = []
    this.current = null
    this.previous = null
    this.movedIndex = 0
    this.movedAfter = 0
    this.overContainer = null

    this.removeAllSeparators = this.removeAllSeparators.bind(this)
    this.onDragOverContainer = this.onDragOverContainer.bind(this)
    this.onMirrorCreated = this.onMirrorCreated.bind(this)
    this.onMirrorMove = this.onMirrorMove.bind(this)
    this.onDragStart = this.onDragStart.bind(this)
    this.onDragStop = this.onDragStop.bind(this)
    this.onDragOver = this.onDragOver.bind(this)
  }

  getOptions() {
    return this.draggable.options.smartq || {}
  }

  attach() {
    this.draggable
      .on("drag:start", this.onDragStart)
      .on("drag:over:container", this.onDragOverContainer)
      .on("mirror:created", this.onMirrorCreated)
      .on("mirror:move", this.onMirrorMove)
      .on("drag:over", this.onDragOver)
      .on("drag:stop", this.onDragStop)
  }

  detach() {
    this.draggable
      .off("drag:start", this.onDragStart)
      .off("drag:over:container", this.onDragOverContainer)
      .off("mirror:created", this.onMirrorCreated)
      .off("mirror:move", this.onMirrorMove)
      .off("drag:over", this.onDragOver)
      .off("drag:stop", this.onDragStop)
  }

  onDragStart(dragEvent) {
    // avoid dragging other elements when a selection exists
    if (
      this.options.selected.length &&
      !this.options.selected.includes(
        parseInt(dragEvent.source.firstElementChild.id || dragEvent.source.children[1].id)
      )
    ) {
      dragEvent.cancel()
      return
    }

    // avoid dragging EOL elements
    /*if (dragEvent.source.classList.contains('bloc--is-eol')) {
      dragEvent.cancel()
      return
    }*/

    this.elements = this.draggable.getDraggableElementsForContainer(dragEvent.sourceContainer)

    this.movedIndex = parseInt(dragEvent.source.firstElementChild.id || dragEvent.source.children[1].id)

    // multi select drag
    if (this.options.selected.length > 1) {
      this.options.selected.map((id) => {
        if (parseInt(dragEvent.source.firstElementChild.id || dragEvent.source.children[1].id) === id) {
          return
        }
        const selectedOriginalSource = document.getElementById(id).parentElement
        const selectedSource = selectedOriginalSource.cloneNode(true)

        selectedOriginalSource.parentNode.insertBefore(selectedSource, selectedOriginalSource)
        selectedOriginalSource.style.display = "none"

        this.selectedMirrors.push({
          source: selectedSource,
          originalSource: selectedOriginalSource,
        })

        selectedOriginalSource.classList.add(this.draggable.getClassNameFor("source:original"))
        selectedSource.classList.add(this.draggable.getClassNameFor("source:dragging"))
      })
    }
  }

  onMirrorCreated({ mirror }) {
    mirror.firstElementChild.classList.remove("bloc--is-selected")
    mirror.style.zIndex = 10000
    this.mirror = mirror

    // multi select drag
    if (this.options.selected.length > 1) {
      mirror.getElementsByClassName("bloc-selected-count")[0].classList.add("bloc-selected-count--is-visible")
    }
  }

  removeAllSeparators() {
    document.querySelectorAll(".separator--is-active").forEach((elt) => {
      elt.classList.remove("separator--is-active")
    })
  }

  onMirrorMove({ mirror, source }) {
    requestAnimationFrame(() => {
      if (!mirror.style.transform.includes("scale")) {
        mirror.style.transform += `scale(.85)`
      }

      if (!this.current) {
        return
      }

      this.removeAllSeparators()

      const mirrorRect = this.mirror.getBoundingClientRect()
      const currentRect = this.current.getBoundingClientRect()

      // case afer last element => unused !! bug when move the first element of a selection containing the last element
      /*if (this.previous) {
        const last = this.elements[this.elements.length - 1];
        const lastRect = last.getBoundingClientRect();
        if (
          mirrorRect.bottom > lastRect.top + lastRect.height / 2 &&
          mirrorRect.left > lastRect.left
        ) {
          if (source !== last) {
            this.current = last;
          } else {
            this.previous = null;
          }
        }
      }*/

      // case first of a line
      let isOverFirst = false
      if (!this.current.firstElementChild.id) {
        if (mirrorRect.right < currentRect.right) {
          this.current.firstElementChild.classList.add("separator--is-active")
          this.movedAfter = parseInt(this.current.children[1].id) - 1
          isOverFirst = true
        } else {
          this.current.firstElementChild.classList.remove("separator--is-active")
        }
      }

      // avoid active separator on previous source
      if (this.current !== source.previousElementSibling) {
        if (mirrorRect.right > currentRect.right) {
          this.current.lastElementChild.classList.add("separator--is-active")
          this.movedAfter = parseInt(this.current.firstElementChild.id || this.current.children[1].id)
        } else {
          this.current.lastElementChild.classList.remove("separator--is-active")
        }
      }

      if (this.previous) {
        if (mirrorRect.left > currentRect.left) {
          this.previous.lastElementChild.classList.remove("separator--is-active")
        } else if (!isOverFirst) {
          this.previous.lastElementChild.classList.add("separator--is-active")
          this.movedAfter = parseInt(this.previous.firstElementChild.id || this.previous.children[1].id)
        }
      }
    })
  }

  onDragOver({ over, source, originalSource, overContainer }) {
    // case over source
    if (over === originalSource || over === source) {
      this.current = null
    } else {
      this.current = over
      this.previous = over.previousElementSibling
    }
  }

  onDragOverContainer({ overContainer }) {
    this.overContainer = overContainer
  }

  onDragStop({ source, originalSource, sourceContainer }) {
    if (this.current || sourceContainer !== this.overContainer) {
      let movedLabelGuid = -1
      // Case answers are listed by label set the new label of the movedIndex if needed
      if (this.options.selectedLabels.length) {
        if (sourceContainer !== this.overContainer) {
          let labelIndex = parseInt(this.overContainer.id.replace(/\D+/g, ""))
          movedLabelGuid = this.options.selectedLabels[labelIndex]
          // if over container is empty, delete the empty grid-item
          if (this.overContainer.firstElementChild.classList.contains("container--is-empty")) {
            this.overContainer.removeChild(this.overContainer.firstElementChild)
          }
        }
      }

      if (this.movedIndex > this.movedAfter) {
        this.movedAfter++
      }

      // multi select drag
      if (this.options.selected.length > 1) {
        let movedIndexes = [this.movedIndex]

        this.selectedMirrors.map(({ source, originalSource }) => {
          movedIndexes.push(parseInt(source.firstElementChild.id || source.children[1].id))

          source.parentNode.insertBefore(originalSource, source)
          source.parentNode.removeChild(source)
          originalSource.style.display = ""
          source.classList.remove(this.draggable.getClassNameFor("source:dragging"))
          originalSource.classList.remove(this.draggable.getClassNameFor("source:original"))
        })

        const smartQMultiMoveEvent = new SmartQMultiMoveEvent({
          movedIndexes: movedIndexes,
          movedAfter: this.movedAfter,
          movedLabelGuid: movedLabelGuid,
        })

        this.draggable.trigger(smartQMultiMoveEvent)

        this.selectedMirrors = []
      } else {
        const smartQMoveEvent = new SmartQMoveEvent({
          movedIndex: this.movedIndex,
          movedAfter: this.movedAfter,
          movedLabelGuid: movedLabelGuid,
        })

        this.draggable.trigger(smartQMoveEvent)
      }
    } else {
      // multi select drag but no move
      if (this.options.selected.length > 1) {
        this.selectedMirrors.map(({ source, originalSource }) => {
          source.parentNode.insertBefore(originalSource, source)
          source.parentNode.removeChild(source)
          originalSource.style.display = ""
          source.classList.remove(this.draggable.getClassNameFor("source:dragging"))
          originalSource.classList.remove(this.draggable.getClassNameFor("source:original"))
        })
      }
    }

    this.current = null
    this.previous = null
    this.selectedMirrors = []

    this.removeAllSeparators()
  }
}
